<template>
    <div class="scc-team-summary">
        <h1 class="scc-team-summary__title">{{ title }}</h1>
        <p class="scc-team-summary__description">{{ description }}</p>
        <template v-if="team">
            <p class="scc-team-summary__subtitle">{{ subtitle }}</p>
            <TeamRankBlock :name="team.name" :amount="team.ticketCount" />
        </template>
    </div>
</template>

<script>
import './team-summary.scss';
import TeamRankBlock from './TeamRankBlock';

export default {
    name: 'TeamSummary',
    components: { TeamRankBlock },
    __editor: {
        fields: {},
    },
    props: {
        team: {
            type: Object,
        },
        description: {
            type: String,
            default:
                'Gaat jouw team aan kop? Check op deze pagina de tussenstand! Ook vind je hier jullie persoonlijke URL en QR-code om met zo veel mogelijk mensen te delen. Alles wat jullie via deze URL delen, wordt toegekend aan jullie team!',
        },
        subtitle: {
            type: String,
            default: 'Jouw team staat op nummer:',
        },
    },
    data() {
        return {};
    },
    computed: {
        title() {
            return this.team?.name || 'Team niet gevonden';
        },
    },
    methods: {},
};
</script>
